import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { BubbleButtonProps } from '../../../client/components/BubbleUI/BubbleButton';

export enum ExtensionPointNamespace {
  UI_MENU = 'go.ui.menu',
  UI_LIBRARY_VENUES_LEFTBAR = 'go.ui.library.venues.leftbar',
  UI_ITINERARY_LEFTBAR = 'go.ui.itinerary.leftbar',
}

export type ExtensionPointProps = {
  namespace: ExtensionPointNamespace;
  events?: any;
  data?: any;
};

// move to shared
interface MenuBarBadge {
  key: string;
  number: number;
  variant: 'crimson' | 'navy';
}

interface MenuBarIconBase {
  key: string;
  icon?: IconProp;
  badges?: MenuBarBadge[];
  title?: React.ReactNode;
}

interface MenuBarLinkIcon {
  type: 'link';
  buttonProps?: BubbleButtonProps;
}

export type UIMenuContribution = MenuBarIconBase & MenuBarLinkIcon;

export type MainMenuExtension = {
  namespace: ExtensionPointNamespace.UI_MENU;
  contribution: UIMenuContribution;
};

export type UILibraryVenuesLeftBarContribution = {
  buttonTitle: string;
};

export type PclItineraryLeftBarContribution = {
  buttonTitle: string;
  from: string;
  to: string;
  logsUrl: string;
};

export type RivieraItineraryLeftBarContribution = {
  buttonTitle: string;
  logsUrl: string;
};

export type UIItineraryLeftBarContribution =
  | PclItineraryLeftBarContribution
  | RivieraItineraryLeftBarContribution;

export type LibraryVenuesLeftBarExtension = {
  namespace: ExtensionPointNamespace.UI_LIBRARY_VENUES_LEFTBAR;
  contribution: UILibraryVenuesLeftBarContribution;
};

export type ItineraryLeftBarExtension = {
  namespace: ExtensionPointNamespace.UI_ITINERARY_LEFTBAR;
  contribution: UIItineraryLeftBarContribution;
};

export type UIImportLogsContribution = {
  buttonTitle: string;
  baseUrl: string;
};

export type ImportLogsExtension = {
  namespace: ExtensionPointNamespace.UI_LIBRARY_VENUES_LEFTBAR;
  contribution: UIImportLogsContribution;
};

export type Extension =
  | MainMenuExtension
  | LibraryVenuesLeftBarExtension
  | ItineraryLeftBarExtension
  | ImportLogsExtension;
